/**
 * Accordions
 */
$('.js-accordion-link').on('click', function(event) {
  event.preventDefault();

  var $this = $(this);
  var $targetElem = $($this.attr('href'));

  if ($this.hasClass('is-active')) {
    $('.js-accordion-link')
      .add($('.js-accordion-item'))
      .removeClass('is-active');

    $('.js-accordion-item').slideUp();
  } else {
    $this.add($targetElem).addClass('is-active');
    $('.js-accordion-link')
      .not($this)
      .removeClass('is-active');

    $('.js-accordion-item')
      .not($targetElem)
      .slideUp();

    $targetElem.slideDown();
  }
});
